import { render } from "./TarotDetailStartButton.vue?vue&type=template&id=2576f982&scoped=true"
import script from "./TarotDetailStartButton.vue?vue&type=script&lang=js"
export * from "./TarotDetailStartButton.vue?vue&type=script&lang=js"

import "./TarotDetailStartButton.vue?vue&type=style&index=0&id=2576f982&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2576f982"]])

export default __exports__